export const apisPath = {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  manager: "/v1",
  users: "/v2",
  public: "/public",
};
